import { fetchApi } from '@/config/axiosSetting';
import { DriverContactInfoParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchContactDriverData/patchContactDriverQuery.type';

export const driverContactQueryFunction = (
  params: DriverContactInfoParamsType,
) => {
  return fetchApi.patch(
    `/property/reports/${params.id}/accident_users/damaged/user_information/driver/contact_information/`,
    params.data,
    {
      params: {
        damaged_id: params?.damaged_id,
        id: params?.id,
      },
    },
  );
};
